import React from "react";
import _ from "lodash";
import styled from "styled-components";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { getParams } from "../hooks/getParams";

const menuList = [
  {
    key: "laiyinSeries",
    path: "/laiyinSeries",
    menuName: "来音系列",
  },
  {
    key: "lingganSeries",
    path: "/lingganSeries",
    menuName: "灵敢系列",
  },
  // {
  //   key: "curriculumSeries",
  //   path: "/curriculumSeries",
  //   menuName: "课程系列",
  // },
  // {
  //   key: "ourProducts",
  //   path: "/ourProducts",
  //   menuName: "音乐类应用",
  //   paths: ["/ourProducts", "/laiyinlianqinTeacher"],
  // },
  // {
  //   key: "moreApplications",
  //   path: "/moreApplications",
  //   menuName: "工具类应用",
  // },
  // { key: "aboutUs", path: "/aboutUs", menuName: "关于我们" },
  // {
  //   key: "socialResponsibility",
  //   path: "/socialResponsibility",
  //   menuName: "社会责任",
  // },
  //   { key: 'moreApplications', path: '/moreApplications', menuName: '更多应用' },
];

export default function Menu() {
  const hideTabKey = getParams("hideTabKey");
  const location = useLocation();

  const currentRoutePath = _.get(location, "pathname");

  return (
    <MenuWrapper>
      {_.map(
        _.filter(menuList, (item) => item.key !== hideTabKey),
        ({ key, path, menuName, paths = [] }) => {
          const isActiveMenu =
            currentRoutePath === path || _.includes(paths, currentRoutePath);
          return (
            <MenuItem
              key={key}
              as={Link}
              to={hideTabKey ? `${path}?hideTabKey=${hideTabKey}` : path}
              className={isActiveMenu ? "active" : ""}
            >
              {menuName}
              <div className="colorBlock" />
            </MenuItem>
          );
        }
      )}
    </MenuWrapper>
  );
}

const MenuWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  font-size: 16px;
`;

const MenuItem = styled.div`
  margin: 0 20px;
  position: relative;
  cursor: pointer;
  /* 现在渲染成 <a>（爬虫能顺着导航走），保持原来的文字颜色和无下划线 */
  color: inherit;
  text-decoration: none;
  > .colorBlock {
    position: absolute;
    width: 40px;
    height: 4px;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: -8px;
  }
  &.active {
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ff950a;
    > .colorBlock {
      position: absolute;
      width: 40px;
      height: 4px;
      background: #ffab18;
      margin: 0 auto;
      left: 0;
      right: 0;
      bottom: -8px;
    }
  }
  &:hover {
    font-family: PingFangSC-Semibold, PingFang SC;
    /* font-weight: 600; */
    color: #ff950a;
  }
`;
